import React from 'react';
import type { UseFormRegister, Path, FieldValues } from 'react-hook-form';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

type FormInputProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    type?: 'text' | 'email' | 'tel' | 'date' | 'time' | 'number';
    register: UseFormRegister<T>;
    registerOptions?: Parameters<UseFormRegister<T>>[1];
    placeholder?: string;
    required?: boolean;
    domainConfiguration: DomainConfigurationDto;
    min?: number;
    max?: number;
    inputMode?: 'text' | 'numeric' | 'email' | 'tel';
    showLabel?: boolean;
};

export default function FormInput<T extends FieldValues>({
    name,
    label,
    type = 'text',
    register,
    registerOptions,
    placeholder,
    required = false,
    domainConfiguration,
    min,
    max,
    inputMode,
    showLabel = true
}: FormInputProps<T>) {
    return (
        <div className="space-y-3">
            {showLabel && (
                <label
                    className="block text-body-14 font-semibold"
                    style={{ color: domainConfiguration.style.onSurfaceColor }}>
                    {label} {required && '*'}
                </label>
            )}
            <input
                type={type}
                inputMode={inputMode}
                min={min}
                max={max}
                {...register(name, registerOptions)}
                className="w-full p-3 border rounded-8 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)]"
                style={
                    {
                        borderColor: withOpacity(domainConfiguration.style.onSurfaceColor, 0.3),
                        backgroundColor: 'transparent',
                        color: domainConfiguration.style.onSurfaceColor
                    } as React.CSSProperties
                }
                placeholder={placeholder}
                aria-label={!showLabel ? label : undefined}
            />
        </div>
    );
}
